import NotImplementedError from './not-implemented'

export default class Spreadsheet {
    /**
     * @abstract
     * @param {string|array|Buffer} data - The raw data to coerce into a spreadsheet-like object
     * @returns {array<object>} The data as an array of objects where each object represents a row and keys in the object represent the columns
     */
    read(data) { throw new NotImplementedError('Spreadsheet.parse must be implemented by a subclass') }
}
